// @flow

import { createBrowserHistory, createMemoryHistory } from "history";

var history;
if (process.env.NODE_ENV === "test") {
  history = createMemoryHistory();
} else {
  history = createBrowserHistory();
}

export default history;
